module.exports = __webpack_public_path__ + "static/media/jasper-5.852051c9.jpg";